import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
/* eslint-disable no-await-in-loop, no-constant-condition */
function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
export function retry(_x) {
  return _retry.apply(this, arguments);
}
function _retry() {
  _retry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(func) {
    var _ref,
      _ref$maxAttempts,
      maxAttempts,
      _ref$maxDelayMs,
      maxDelayMs,
      delay,
      attempts,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref$maxAttempts = _ref.maxAttempts, maxAttempts = _ref$maxAttempts === void 0 ? 10 : _ref$maxAttempts, _ref$maxDelayMs = _ref.maxDelayMs, maxDelayMs = _ref$maxDelayMs === void 0 ? 60 * 1000 : _ref$maxDelayMs;
            delay = 1000;
            attempts = 0;
          case 3:
            if (!true) {
              _context.next = 20;
              break;
            }
            _context.prev = 4;
            _context.next = 7;
            return func();
          case 7:
            return _context.abrupt("return", _context.sent);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            attempts += 1;
            if (!(attempts >= maxAttempts)) {
              _context.next = 15;
              break;
            }
            throw _context.t0;
          case 15:
            delay = Math.min(delay * Math.pow(2, attempts - 1), maxDelayMs);
            _context.next = 18;
            return wait(delay);
          case 18:
            _context.next = 3;
            break;
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _retry.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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